/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Placeholder_TagsInputs */

const en_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const de_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const fr_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const es_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const it_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const nl_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const pl_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const fi_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const da_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

const sv_story_bank_placeholder_tags = /** @type {(inputs: Story_Bank_Placeholder_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leadership, migration, teamwork`)
};

/**
* | output |
* | --- |
* | "leadership, migration, teamwork" |
*
* @param {Story_Bank_Placeholder_TagsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_placeholder_tags = /** @type {((inputs?: Story_Bank_Placeholder_TagsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Placeholder_TagsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_placeholder_tags(inputs)
	if (locale === "fr") return fr_story_bank_placeholder_tags(inputs)
	if (locale === "es") return es_story_bank_placeholder_tags(inputs)
	if (locale === "it") return it_story_bank_placeholder_tags(inputs)
	if (locale === "nl") return nl_story_bank_placeholder_tags(inputs)
	if (locale === "pl") return pl_story_bank_placeholder_tags(inputs)
	if (locale === "fi") return fi_story_bank_placeholder_tags(inputs)
	if (locale === "da") return da_story_bank_placeholder_tags(inputs)
	if (locale === "sv") return sv_story_bank_placeholder_tags(inputs)
	return en_story_bank_placeholder_tags(inputs)
});